import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';

export var WidgetCustomVideo: Widget = {
    type: 'customContentVideo',
    id: '1',
    name: 'Video',
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Video',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
    },
};
